import { AGENT_STATE, WEB_EVENTS, MODES } from "../constants";
import { callEndActions, handleConferenceHoldState, pauseAfterCall, pauseToggle, removeConferenceNumber, removeTransferNumber, resetCallSlice, setAlwaysOnCallConnected, setIsCallIncomming, setWrapUpTimeExceeded } from "../context/callSlice";
import { store } from "../context/store";
import { closeTab, loading, logout, setAgentLogoffByAdmin, setAgentState, setAleadyLoggedIn, setBarginRecording, setCallOnChatORChatOnCallAvailable, setDispositionValues, setIsExceptionState, setLoginViaAppData, setLogoutTimer, setNotificationData, setUsId, setWarmTransferdisableHoldButton, setWarmTransferEnableCallEndbutton, setWebsocketConnectionStatus } from "../context/toolbarSlice";
import { handleNewAcceptedChatRequest, handleChatEndedByCustomer, handleNewIncomingChatRequest, setChatScreenpops, resetDigitalSlice, setDigitalChatChannelType, setFirstSessions, addDeclinedChatsMonitorUcids, showPauseAfterSessionTime, pauseAfterSession, handleAgentSubUserChat } from "../context/digitalSlice";
import Logger from "./logger.service";
import { handleReconnect, handleReload, handleToolbarPause, webSocketLoginAuth } from "./authService";
import sipService from "./sip.service";
import { showErrorNotification, showInfoNotification, showSuccessNotification } from "../components/common/NotiService";
import { convertingToDateTimeStringFormat, handleAgentRelease, handleCallAnswered, handleCallEndData, handleDropCall, handleEndBeep, handleNewCall, handleNewIncommingMsg, pauseAgent, releaseAgent, timeStampToLocalTime, handleScreenPopClose, handleTranscribe, handleTranscribeTab, removeTranscribeTab, handleToolbarRelease, } from "./webEventHandlers";
import { handleChatAcceptStatus } from "../context/digitalSlice";
import { clearSession, displayChatOnCallMiniWindow, findPauseReason, getAgentData, getParam, getPauseReasons, getPreviewCampaings, getPreviewNumber, getToolbarState, addInteractionTab, handlePreviewReset, handleScreenRecording, isLoginDataPresent, isSettingEnabled, isUcidRecordingMode, notifyNewChat, PreviewReset, resetPreviewNumber, setAgentDataBeforeReload, updateTimer, isMobileApp, getRoleStatus, finalRecording, closePreviewScreenpop, closeAllPreviewScreenpops } from "./util";
import MessageService from "./message.service";
import { handleTbNotifications } from "./notificationHandler";
import { aToolbar } from "../toolbar";
import { addNewTab, setActiveTab } from "../context/dashboardSlice";
import { agentService, getEmailConversation, useReqCounter } from "./agent.service";
import LocalStorageService from "./localstorage.service";
import { setAgentStateDuration, setPauseReason, setReUpdateTimer, setWrapUpTime } from "../context/timerSlice";
import { goToLogin } from "./navigation";

const WSocketService = (function () {
    let services = {}
    let socket = null;
    let loginAddress = [];
    let connectionEvent = 'login'
    let agentForceLogoutByAdmin = false;
    let heartbeatInterval = null;
    let hiddenReconnectTimer = null;
    let pageHiddenAt = 0;
    let internetStatus = true;
    let queueCheckTimer = null;
    let isRequestPending = false;

    document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
            pageHiddenAt = Date.now();
        } else {
            clearTimeout(hiddenReconnectTimer);
            hiddenReconnectTimer = null;
        }
    });

    window.onbeforeunload = function (event) {
        store.dispatch(setAleadyLoggedIn(false));
        store.dispatch(setLoginViaAppData({
            customer: null,
            agentid: null,
            phoneNumber: null,
            pin: null
        }))
    }
    services.initConnection = function (event) {
        try {

            let data = getAgentData();
            let finalURL = getLoginIP(data.agentLoginIP);    // getting this value from agent login details 
            connectionEvent = event;
            let isPortIncluded = data?.agentLoginIP?.indexOf(':') > -1;
            if (finalURL) {
                if (!isPortIncluded || finalURL.includes("amazonaws.com")) {
                    Logger.log('[AWS]', "Connecting to  AWS websocket")
                    socket = new WebSocket(finalURL);
                }
                else {
                    Logger.log('[AWS]', "Connecting to jwebsocket")
                    socket = new WebSocket(finalURL, "org.jwebsocket.json");
                }
            }
            socket.onopen = function (e) {
                Logger.info('[AWS]', 'Websocket connected');
                store.dispatch(setWebsocketConnectionStatus(true));
            }
            socket.onmessage = function (event) {
                services.handleSocketMessage(JSON.parse(event.data));
            }
            socket.onerror = function (e) {
                Logger.error('[AWS]', 'Error with websocket:', e);
                store.dispatch(setWebsocketConnectionStatus(false));
                if (queueCheckTimer) {
                    clearInterval(queueCheckTimer);
                }
            }
            socket.onclose = function (e) {
                store.dispatch(setWebsocketConnectionStatus(false));
                Logger.log('[AWS]', 'websocket closed'
                    + ' code=' + (e?.code ?? 'NA')
                    + ' reason="' + (e?.reason || 'NA') + '"'
                    + ' wasClean=' + (e?.wasClean ?? 'NA')
                    + ' type:' + (e?.type || 'NA')
                    + ' internet=' + internetStatus
                    + ' readyState=' + socket?.readyState
                    + ' raw=' + JSON.stringify(e));
                if (queueCheckTimer) {
                    clearInterval(queueCheckTimer);
                }
            }
        }
        catch (e) {
            Logger.error('[AWS]', "Error while connecting to websocket " + JSON.stringify(e));
            store.dispatch(setWebsocketConnectionStatus(false));
        }
    }

    services.isSocketConnected = function (printLog = true) {
        if (socket) {
            if (printLog) Logger.log('[AWS]', "websocket connected ready state: " + socket.readyState);
            return (socket.readyState !== WebSocket.CLOSED) && (socket.readyState !== WebSocket.CLOSING) && (socket.readyState !== WebSocket.CONNECTING)
        } else {
            return false;
        }
    }
    services.isSocketConnecting = function () {
        return socket ? (socket.readyState === WebSocket.CONNECTING) : false
    }
    services.isSocketClosed = function (printLog = true) {
        if (socket) {
            if (printLog) Logger.log('[AWS]', "websocket closed Socket ready state: " + socket.readyState);
            return (socket.readyState === WebSocket.CLOSED)
        } else {
            return true;
        }
    }
    services.send = function (message) {
        try {
            if (services.isSocketConnected(false) && !isRequestPending) {
                isRequestPending = true; // Set the pending flag
                socket.send(message);
                setTimeout(() => {
                    isRequestPending = false; // Clear the pending flag after 5 seconds 
                }, 5000);
            } else if (!services.isSocketConnected(false)) {
                Logger.log('[AWS]', 'websocket connection not available: ' + socket.readyState);
            }
        }
        catch (e) {
            Logger.error('[AWS]', "Exception while sending message to websocket:" + JSON.stringify(e))
        }
    }
    services.closeConnection = function () {
        try {
            if (!services.isSocketConnected()) {
                Logger.log('[AWS]', "websocket conection already Closed")
                return;
            }
            socket.close();
        }
        catch (e) {
            Logger.error('[AWS]', "Exception while closing websocket connection", e)
        }
    }

    services.setAgentForceLogoutByAdmin = async function (status) {
        agentForceLogoutByAdmin = status;
    }

    services.getAgentForceLogoutByAdmin = function () {
        return agentForceLogoutByAdmin;
    }

    const logoutOnClose = async () => {
        console.log('logoutOnClose')
        store.dispatch(loading(true));
        store.dispatch(handleChatAcceptStatus(false))
        try {
            const resp = await agentService("tbAgentLogout", { params: store.getState().toolbar.agent.mode.toUpperCase(), logoutBy: 'logoffByAgent', })
            let respKeys = Object.keys(resp);
            if (respKeys.includes('resp')) {
                if (resp.resp === "Success") {
                    handleScreenRecording("logout", "stop")
                        let showingToolbarInCrm = store?.getState()?.toolbar?.showingToolbarInCrm;
                    window.parent.postMessage({ action: "logout", token: {} }, "*");
                    aToolbar !== undefined && aToolbar.trigger("logout");
                    store.dispatch(logout());
                    clearSession();
                    store.dispatch(loading(false));
                    showSuccessNotification("Logout Successful");
                    Logger.info("Logout successful");
                    store.dispatch(resetCallSlice());
                    store.dispatch(resetDigitalSlice());
                    if (showingToolbarInCrm) {
                        goToLogin();
                    }
                }
            } else {
                Logger.error("Logout Un-successful, " + JSON.stringify(resp))
                showErrorNotification('Logout Un-successful');
            }
            store.dispatch(loading(false));
        } catch (e) {
            Logger.error('Unable to logout', e);
            store.dispatch(loading(false));
            showErrorNotification('Logout Un-successful');
        }
    }

    services.checkSession = async function () {
        let reconnect = localStorage.getItem('reconnect');
        let sessionReconnect = sessionStorage.getItem('sessionReconnect');
        if (reconnect === 'true' || WSocketService.isSocketClosed()) {
            if (WSocketService.isSocketClosed()) {
                if ((getParam("LOGOUT_ON_REFRESH") === "true") && sessionReconnect && sessionReconnect === 'true') {
                    logoutOnClose();
                }
                else {
                    Logger.info('[AWS]', "Reconnecting websocket...")
                    WSocketService.initConnection('refresh')
                }
            } else {
                Logger.info('[AWS]', "websocket already connected...")
            }
        }
        window.onbeforeunload = function (event) {
            setAgentDataBeforeReload();
        };

    }
    window.onunload = function () {
        handleScreenRecording("unload", "stop");
        const MANUAL_CALL_RETRY = store.getState().toolbar.params.MANUAL_CALL_RETRY;
        if (sipService.isSIPEnabled && store.getState().call.isComponentOnCall) {
            sipService.sipDecline();
            if (MANUAL_CALL_RETRY === false || MANUAL_CALL_RETRY === "false") {
                handleDropCall({ callStatus: "Call disconnected", ucid: store.getState().call.callDetails ? store.getState().call.callDetails.ucid : '' });
            }
        }
    }

    services.updateInternetStatus = function (status) {
        internetStatus = status;
    }

    services.reviveToolbar = function () { // called when internet lost 
        const isLoggedIn = localStorage.getItem('isLoggedIn');
        if (isLoggedIn === true || isLoggedIn === 'true') {
            Logger.log('reviving toolbar')
            showErrorNotification("Websocket connection lost, reconnecting...");
            if (!services.isSocketClosed()) services.closeConnection();
            services.initConnection('reconnect')
        } else {
            Logger.log('Not reviving toolbar, login status:', isLoggedIn)
        }
    }
    services.stopHeartbeatService = function (status) {
        stopHeartbeat();
    }

    services.startHeartbeatService = function () {
        if (!services.isSocketClosed()) services.closeConnection(); //closing existing websocket before reconnecting
        setTimeout(() => {   
            startHeartbeat();
        }, [2000])
    }

    services.handleSocketMessage = async function (message) {
        if (message.type === "response") Logger.info('[AWS]', "Received heartbeat response from server");
        else Logger.info('[AWS]', 'Received websocket event:  Message type--------->: ' + message.type);

        switch (message.type) {
            case WEB_EVENTS.response:
                break;
            case WEB_EVENTS.welcome:
                welcomeMessage(message);
                break;
            case WEB_EVENTS.newCall:
                handleNewCall(message);
                break;
            case WEB_EVENTS.InternalDial:
                handleNewCall(message);
                break;
            case WEB_EVENTS.dropCall:
                store.dispatch(setIsExceptionState(false));
                await handlePreviewReset("reset");
                await handlePreviewReset("getPrevNum");
                handleDropCall(message);
                break;
            case WEB_EVENTS.agentCallAnswered:
                handleAgentCallAnswered(message);
                break;
            case WEB_EVENTS.agentCallDisconnected:
                handleAgentCallAnswered(message);
                break;
            case WEB_EVENTS.performCallEvent:
                sipService.sipAccept();
                break;
            case WEB_EVENTS.decline:
                sipService.sipDecline();
                break;
            case WEB_EVENTS.agentReleaseWOACW:  // agent release without ACW
                message.ucid = store.getState().call?.callDetails ? store.getState().call.callDetails.ucid : '';
                await handlePreviewReset("reset");
                await handlePreviewReset("getPrevNum");
                handleDropCall(message);
                break;
            case WEB_EVENTS.agentLogoffByAdmin:
                handleAgentLogoffByAdmin(message);
                break;
            case WEB_EVENTS.agentReleaseByAdmin:
                handleAgentReleaseByAdmin(message);
                break;
            case WEB_EVENTS.busyAgent:
                handleCallAnswered(message);
                break;
            case WEB_EVENTS.agentRelease:
                handleEndBeep();
                handleAgentRelease(message)
                break;
            case WEB_EVENTS.pauseFromApi:
                handlePauseFromApi(message);
                break;
            case WEB_EVENTS.incomingConferenceCall:
                handleNewCall(message);
                const newParam = { ...message, agentId: getAgentData().agentUserName || '', startTime: convertingToDateTimeStringFormat() }
                aToolbar !== undefined && aToolbar.trigger("incomingConferenceCall", [newParam]);
                window.parent.postMessage({ action: "incomingConferenceCall", token: newParam }, "*");
                break;
            case WEB_EVENTS.conferenceStart:
                handleCallAnswered(message);
                aToolbar !== undefined && aToolbar.trigger("conferenceStart", [message]);
                break;
            case WEB_EVENTS.conferenceEnd:
                handleConferenceEnd(message)
                break;
            case WEB_EVENTS.incomingChat: // incoming new chat auto answer setting disable case
                addInteractionTab(true);
                newChatSession(message)
                break;
            case WEB_EVENTS.chatonmulti:  // auto answer setting enabled case new incoming chat 
                addInteractionTab(true);
                try {
                    if (isMobileApp()) {
                        let res = await MessageService.fetchChatSession(message.sessionId);
                        message.currentChatHist = res?.currentChatHist || [];
                        message.previousChatHist = res?.previousChatHist || [];
                    }
                } catch (e) {
                    console.log("FCM token error:", e)
                }
                handleNewChatSession(message);
                break;
            case WEB_EVENTS.inchatmulti:
                // incoming msg from user only text msg
                handleNewIncommingMsg(message)
                break;
            case WEB_EVENTS.custMediaMsg:
                // incoming media msg from user 
                handleNewIncommingMsg(message)
                break;
            case WEB_EVENTS.custLocation:
                handleNewIncommingMsg(message)
                break;
            case WEB_EVENTS.custEnd:
                handleChatEndByCustomer(message)
                break;
            case WEB_EVENTS.closeTab:
                handleCloseTab()
                break;
            case WEB_EVENTS.callDetails:
                handleCallEndData(message);
                break;
            case WEB_EVENTS.agentAlert:
                handleNotificationData(message)
                break;
            case WEB_EVENTS.chatMessage:
                handleNotificationData(message)
                break;
            case WEB_EVENTS.agentTransferBusy:
                handleTransferBusy(message)
                break;
            case WEB_EVENTS.agentTransferEnd:
                handleTransferEnd(message)
                break;
            case WEB_EVENTS.agentPauseBySystem:
                handleAgentPause(message)
                break;
            case WEB_EVENTS.transcribeText:
                handleTranscribe(message);
                break
            case WEB_EVENTS.toolbarPause:
                localStorage.setItem("pauseTime", new Date());
                handleToolbarPause(message);
                break
            case WEB_EVENTS.toolbarRelease:
                handleToolbarRelease();
                break
            case WEB_EVENTS.agentConferenceStart:
                handleAgentConferenceStart(message);
                break
            case WEB_EVENTS.AgentSubUserChat:
                handleAgentToSubUserMsg(message);
                break
            case WEB_EVENTS.agentBarginStart:
                screenRecordingBarginStart(message);
                break
            case WEB_EVENTS.agentBarginEnd:
                screenRecordingBarginEnd(message);
                break

            default:
                handleDefaultMessage(message);
                break;
        }
    }
    function startHeartbeat() {
        try {
            stopHeartbeat();
            const agentId = getAgentData()?.agentInfo?.agentId;
            heartbeatInterval = setInterval(() => {
                Logger.log('[AWS]', 'Toolbar Heartbeat status for server:', services.isSocketConnected(false), ' internet:', internetStatus);
                // if (!internetStatus) {
                //     Logger.log('Internet connection lost');
                //     return;
                // }
                if (services.isSocketConnected(false)) {
                    services.send(JSON.stringify({ echo: false, ns: "ozonetel.cloudagent", type: "IS_ALIVE", utid: useReqCounter(), agentId }));
                } else {
                    if (!services.isSocketConnecting()) {
                        Logger.log('[AWS]', 'No existing websocket connection found, Toolbar, reconnecting...');

                        if (!document.hidden) {
                            const visTimerSetAt = Date.now();
                            setTimeout(() => {
                                if (Date.now() - visTimerSetAt > 3000) return;
                                if (!document.hidden && !services.isSocketConnecting() && !services.isSocketConnected(false)) {
                                    // console.log("Reconnect is going");
                                    services.reviveToolbar();
                                }
                            }, 1500);
                        } else {
                            if (!hiddenReconnectTimer) {
                                hiddenReconnectTimer = setTimeout(() => {
                                    hiddenReconnectTimer = null;
                                    if (document.hidden && !services.isSocketConnecting() && !services.isSocketConnected(false)) {
                                        // console.log("Reconnect2 is going")
                                        services.reviveToolbar();
                                    }
                                }, 11000);
                            }
                        }
                    }
                }
            }, 5000);
        } catch (e) {
            Logger.log('[AWS]', 'Error While startHeartbeat: ' + JSON.stringify(e));
        }
    }

    async function screenRecordingBarginStart() {
        const isScreenAlreadyRecording = store.getState().toolbar.isScreenRecordingEnabled;
        console.log("screen->Recording :: received screen record ---> bargin start-->");
        if (!isScreenAlreadyRecording) { // to handle, on login if cancelled by agent.
            const ROLE_SCREEN_RECORDING = getRoleStatus("ROLE_SCREEN_RECORDING");
            if (ROLE_SCREEN_RECORDING ) {
                finalRecording('bargin', 'start');
                store.dispatch(setBarginRecording(true));
            }
        } else { //  on login started and paused then resuming
            const ROLE_SCREEN_RECORDING = getRoleStatus("ROLE_SCREEN_RECORDING");
            if (ROLE_SCREEN_RECORDING ) {
                finalRecording('bargin', 'resume');
                store.dispatch(setBarginRecording(true));
            }
        }
    }

    async function screenRecordingBarginEnd() {
        const isScreenAlreadyRecording = store.getState().toolbar.isScreenRecordingEnabled;
        const SCREEN_RECORD_BY_APP = isSettingEnabled("SCREEN_RECORD_BY_APP");
        const ROLE_SCREEN_RECORDING = getRoleStatus("ROLE_SCREEN_RECORDING");
        const barginRecording = ROLE_SCREEN_RECORDING
        const busyScreen = store.getState().call.isCallAttended;
        const isACWscreen = store.getState().call.isCallEnded;
        store.dispatch(setBarginRecording(false));
        console.log("screen->Recording :: received screen record --> bargin End-->");
        if (isScreenAlreadyRecording && !SCREEN_RECORD_BY_APP) {
            if (barginRecording && !isUcidRecordingMode()) {
                console.log("screen->Recording :: bargin end, so pausing the screen recording not UCID based true");
                finalRecording('bargin', 'pause');
            }
            else if (barginRecording && isUcidRecordingMode() && !busyScreen && !isACWscreen) {
                console.log("screen->Recording :: bargin end, so pausing the screen recording : agent not in busy or acw screen so pausing");
                finalRecording('bargin', 'pause');
            }
        }
        else if (SCREEN_RECORD_BY_APP) {
            if (barginRecording && !isUcidRecordingMode()) {
                console.log("screen->Recording :: bargin end, so pausing the screen recording not UCID based true");
                finalRecording('bargin', 'pause');
            }
            else if (barginRecording && isUcidRecordingMode() && !busyScreen && !isACWscreen) {
                console.log("screen->Recording :: bargin end, so pausing the screen recording using APP : agent not in busy or acw screen so pausing");
                finalRecording('bargin', 'pause');
            }
        }
    }

    function stopHeartbeat() {
        clearInterval(heartbeatInterval);
    }
    async function handleAgentConferenceStart(message) {
        try {
            let MERGE_AGT_CONF = isSettingEnabled('MERGE_AGT_CONF')
            let conferenceList = store.getState().call.conferenceData;
            if (MERGE_AGT_CONF) {
                let updatedConferenceList = conferenceList.map((e) => {
                    if (e.person === message?.confPhoneNumber) {
                        return { ...e, status: "Connected" }; // Return a new object with updated status
                    }
                    return e; // Return the original if condition doesn't match
                });
                store.dispatch(handleConferenceHoldState(updatedConferenceList));
            }
        }
        catch (e) {
            Logger.error(e);
        }
    }
    async function handleAgentToSubUserMsg(message) {
        if (message) {
            message.senderId = message.subUserId;
            message.senderName = message.subUserName;
            message.content = message.msg;
            message.timestamp = new Date();
            handleTbNotifications({ type: "chatMessage", msg: message.content, alertType: "Notice" });
            store.dispatch(handleAgentSubUserChat(message))
        }
    }
    async function handleAgentPause(message) {
        const pauseAfterSessionEnabled = store.getState().digital.pauseAfterSession;
        const isSIPconnected = store.getState().toolbar.isSIPconnected;
        const isSIPEnabled = store.getState().toolbar.loginDetails.isSip;
        const pauseAfterCallStatus = store.getState().call.pauseAfterCallStatus;
        let pauseTime = Number(message?.pauseTime || findPauseReason(message?.reason) || 0);
        let tamp = {
            reason: message?.reason,
            timeLimit: pauseTime
        };
        store.dispatch(setPauseReason(tamp))
        if (pauseAfterSessionEnabled) {
            store.dispatch(pauseAfterSession({ type: false, reason: null }))
            store.dispatch(showPauseAfterSessionTime(true))
        }
        if (pauseAfterCallStatus) {
            store.dispatch(pauseAfterCall({ type: false, reason: null }));
            store.dispatch(pauseToggle(false));
        }
        store.dispatch(pauseToggle(false));
        store.dispatch(setReUpdateTimer(true));
        store.dispatch(setAgentStateDuration(0));
        if (!isSIPconnected || !isSIPEnabled) {
            showSuccessNotification(`Pause Reason: ${message.reason}, TimeLimit: ${pauseTime} Sec`)
        }
        Logger.info(`Agent State Successfully changed to Pause. Reason: ${message.reason},TimeLimit: ${pauseTime} Seconds`)
        LocalStorageService.setItem("maxPauseTime", pauseTime);
        store.dispatch(setAgentState(AGENT_STATE.NOT_READY));
        store.dispatch(loading(false));

        store.dispatch(setLogoutTimer(true));
        const startTime = Date.now();
        LocalStorageService.setItem("logoutStartTime", startTime);
        // Logger.info('Agent State changed to Pause');
        store.dispatch(setDispositionValues("clear"));
        if (store.getState().call.isCallEnded) {
            store.dispatch(callEndActions());
            store.dispatch(setWrapUpTime(0));
        }
    }
    async function handleTransferBusy(message) {
        console.log('transfer busy------------>agentTransferBusy')
        store.dispatch(setWarmTransferEnableCallEndbutton(true));
    }
    async function handleTransferEnd(message) {
        const warmTranferEnableCallEndbutton = store.getState().toolbar.warmTranferEnableCallEndbutton;
        const warmTranferDisableHoldButton = store.getState().toolbar.warmTranferDisableHoldButton;
        console.log("agentTransferEnd ----------->agentTransferEnd")
        if (warmTranferEnableCallEndbutton) {
            store.dispatch(setWarmTransferEnableCallEndbutton(false))
        }
        if (warmTranferDisableHoldButton) {
            store.dispatch(setWarmTransferdisableHoldButton(false));
        }
        store.dispatch(removeTransferNumber([]));
        store.dispatch(loading(false));
    }
    async function handleCloseTab() {
        agentForceLogoutByAdmin = true;
        localStorage.setItem('closeTab', true);
        PreviewReset();
        handleScreenRecording("closeTab", "stop");
        store.dispatch(closeTab(true));
        let showingToolbarInCrm = store?.getState()?.toolbar?.showingToolbarInCrm;
        window.parent.postMessage({ action: "logout", token: {} }, "*");
        aToolbar !== undefined && aToolbar.trigger("logout");
        let search = window.location.search;
        if (search && search.length && search.includes('action=formLogin')) {
            search = search.replace(/[\\?|&]?(action=formLogin&)/ig, "")
            console.log("closeTab ->: navigating to login page");
            window.location.href = '/login?' + search;
        } else if (showingToolbarInCrm) {
            goToLogin();
        } else {
            console.log("closeTab -> showingToolbarInCrm : navigating to login page");
            window.location.href = '/login'
        }
    }

    function getLoginAddress(loginIp) {
        try {
            if (loginAddress.length === 0) {
                loginIp.split(',').forEach((element, index) => {
                    loginAddress[index] = { "ip": element, "tries": 0, "lastTime": null, "serverName": (index % 2 === 0 ? "primary" : "secondary") };

                });
            } else {
                if (loginAddress.length > 1) {
                    if (loginAddress[0].tries >= 0 && loginAddress[0].tries < 2) {
                        loginAddress[0].tries++;
                        loginAddress[0].lastTime = new Date();
                    } else {
                        loginAddress[1].tries++;
                        loginAddress[1].lastTime = new Date();
                        loginAddress[0].tries = 0;
                        loginAddress.push(loginAddress[0]);
                        loginAddress.shift();
                    }
                }
            }
            return loginAddress[0].ip

        } catch (e) {
            Logger.error('[AWS]', 'Websocket: Error while parsing login url ' + JSON.stringify(e))
            return null
        }
    }


    function getLoginIP(url) {

        let eLoginIp = getLoginAddress(url);
        let finalUrl = null;
        if (eLoginIp != null && eLoginIp !== "") {
            if (window.location.protocol.indexOf("https") > -1) {
                if (eLoginIp.indexOf(':') > -1) {
                    var port = eLoginIp.substring(eLoginIp.indexOf(":") + 1);
                    eLoginIp = eLoginIp.replace(port, parseInt(port) + 1010);
                    finalUrl = "wss://" + eLoginIp;
                }
                else {
                    finalUrl = "wss://" + eLoginIp;
                }
            } else {
                Logger.info('[AWS]', eLoginIp, (eLoginIp.indexOf(':') > -1) ? "Port is part of my life" : "I have no port");
                finalUrl = "ws://" + eLoginIp + (eLoginIp.indexOf(':') > -1 ? "" : ":8787");
            }
        }
        return finalUrl;
    }

    function welcomeMessage(message) {
        if (message.sourceId != null) {
            if (isMobileApp()) {
                store.dispatch(setUsId('MOB~' + isMobileApp()))
            } else {
                store.dispatch(setUsId(message.usid))
            }
            const onAuthSuccess = () => {
                try {
                    sipService.loadSIP();
                } catch (e) {
                    console.log('sip connection error :: ', e);
                }
                setTimeout(() => {
                    startHeartbeat();
                }, 5000);
            };
            if (connectionEvent === 'refresh') {
                const onReloadFail = () => {
                    setTimeout(() => handleReload(onAuthSuccess), 3000);
                };
                handleReload(onAuthSuccess, onReloadFail)
            } else if (connectionEvent === 'reconnect') {
                const mode = store.getState()?.toolbar?.agent?.mode || undefined;
                const onReconnectFail = () => {
                    setTimeout(() => handleReconnect(mode, onAuthSuccess), 3000);
                };
                handleReconnect(mode, onAuthSuccess, onReconnectFail)
            } else {
                webSocketLoginAuth()
                onAuthSuccess();
            }
        }
    }

    function handleDefaultMessage(message) {
        if (message.type !== undefined) {
            Logger.error('[AWS]', "Token Triggering.." + message.type);
            if (message.type === "agentAlert") {
                showInfoNotification('agentAlert: ' + message.msg);
            } else if (message.type !== "response") {
                Logger.info('[AWS]', "Websocket event not found ", message);
            } else {
                return;
            }
        }
    }

    function handlePauseFromApi(message) {
        message.ucid = store.getState().call.callDetails ? store.getState().call.callDetails.ucid : '';
        handleDropCall(message);
    }

    function handleAgentCallAnswered(message) {
        const alwaysOnCallConnected = message.type === "alwaysOnCallConnected" ? true : false;
        setAlwaysOnCallConnected({ alwaysOnCallConnected: alwaysOnCallConnected, alwaysOnCallUcid: "" });
    }

    function handleConferenceEnd(message) {
        let cloneConfData = structuredClone(store.getState().call.conferenceData)
        cloneConfData = cloneConfData.filter((data) => {
            return data.person !== message.custNumber
        }
        )
        store.dispatch(removeConferenceNumber(cloneConfData))
        store.dispatch(loading(false));
        showSuccessNotification("Conference call ended Successfully")
    }

    function handleNotificationData(message) {
        Logger.info("Recived Notification")
        if (message.type === "chatMessage") {
            message.alertType = message.Sender
        }
        message.operation = "push"
        handleTbNotifications(message);
        store.dispatch(setNotificationData(message));
    }

    async function handleChatEndByCustomer(message) {
        let answerdChats = store.getState().digital.answeredChats;
        let unAnsweredChats = store.getState().digital.unansweredChats;
        if (unAnsweredChats[message.chatCustSessionId] || answerdChats[message.chatCustSessionId]) {
            if (unAnsweredChats[message.chatCustSessionId]) {
                let res = await MessageService.handleUnAnsweredChatEndedByCustomer(message)
                if (res && Object.values(answerdChats).length < 1 && Object.values(unAnsweredChats).length <= 1) {
                    releaseAgent()
                    store.dispatch(handleChatEndedByCustomer(message))
                }
                else {
                    store.dispatch(handleChatEndedByCustomer(message))
                }
                for (var key in unAnsweredChats) {
                    if (unAnsweredChats.hasOwnProperty(key)) {
                        var chat = unAnsweredChats[key];
                        if (key === message.chatCustSessionId) {
                            store.dispatch(addDeclinedChatsMonitorUcids(chat.chatDetails.monitorUcid));
                        }
                    }
                }
                aToolbar !== undefined && aToolbar.trigger("disposeChat", [res]);
            }
            else {
                store.dispatch(handleChatEndedByCustomer(message))
            }
        }
    }

    async function handleNewChatSession(incommingSession) { // incoming new chat ( auto answer is enabled case)
        await PreviewReset(true)
        displayChatOnCallMiniWindow();
        const EMAIL_HOST = store.getState().toolbar.params.EMAIL_HOST;
        const EMAIL_APIKEY = store.getState().toolbar.params.EMAIL_APIKEY;
        let answerdChats = store.getState().digital.answeredChats;
        let chatAutoAnswer = getParam('CHAT_AUTO_ANSWER');
        if (chatAutoAnswer === true || chatAutoAnswer === 'true') {
            notifyNewChat(incommingSession);
        }
        let chatObj = JSON.parse(incommingSession.chatDetails)
        if (chatAutoAnswer === "true") {
            if (!(store.getState().digital.declinedChatsMonitorUcids.includes(chatObj.monitorUcid))) {
                let obj = { ...incommingSession, chatDetails: JSON.parse(incommingSession.chatDetails), monitorUcid: chatObj.monitorUcid, ucid: chatObj.monitorUcid, did: chatObj.did, skillName: chatObj.skill, callerId: chatObj.phoneNumber || '', callType: `Digital - ${chatObj.channelType} `, callStartTime: new Date().toISOString() }
                aToolbar !== undefined && aToolbar.trigger("chatonmulti", [obj]);
            }
        }
        if (Object.keys(answerdChats).length === 0) {
            updateTimer(true);
        }
        store.dispatch(setFirstSessions(incommingSession.sessionId));
        store.dispatch(handleNewAcceptedChatRequest(incommingSession))
        handleChatScreenPop(incommingSession)
        store.dispatch(loading(false));
        let data = JSON.parse(incommingSession.chatDetails)
        if (data && data.channelType && data.channelType === 'email') {
            store.dispatch(setDigitalChatChannelType(data.channelType))
            let reqBody = {
                host: EMAIL_HOST,
                key: EMAIL_APIKEY,
                emailId: data.recipient,
                conversationId: data.sessionId
            }
            getEmailConversation(reqBody)
        }
    }

    function getChatScreenPopUrl(data) {
        let screenUrl = null
        var o_custName = data.chatDetails.chatCustName || data.chatDetails.phoneNumber || "Anonymous";
        if (data.token.screenPop && data.token.screenPop !== null && data.token.screenPop !== "" && data.token.screenPop.trim().startsWith("http")) {
            screenUrl = data.token.screenPop + encodeURIComponent(data.chatDetails.phoneNumber || (data.chatDetails.chatCustId ? data.chatDetails.chatCustId.replace(/[sms\:|whatsapp\:]/ig, "") : ""))
                + "&custName=" + encodeURIComponent(o_custName)
                + "&email=" + encodeURIComponent(data.chatDetails.email)
                + "&ucid=" + encodeURIComponent(data.chatDetails.monitorUcid)
                + "&skill=" + encodeURIComponent(data.chatDetails.skill)
                + "&callerID=" + encodeURIComponent(data.chatDetails.phoneNumber)
                + "&did=" + encodeURIComponent(data.chatDetails.did)
                + "&skillName=" + encodeURIComponent(data.chatDetails.skill)
                + "&agentUniqueID=" + encodeURIComponent(getAgentData().agentUniqId)
                + "&campaignID=" + encodeURIComponent(data.chatDetails.campaignId)
                + "&monitorUcid=" + encodeURIComponent(data.chatDetails.monitorUcid)
                + "&agentPhoneNumber=" + encodeURIComponent(getAgentData().phoneNumber)
                + "&type=Chat"
                + "&agentID=" + encodeURIComponent(data.chatDetails.agentId)
                + "&customer=" + encodeURIComponent(data.chatDetails.caUserName)
                + "&apiKey=" + encodeURIComponent(getAgentData().agentInfo.user.apiKey)
        }
        return screenUrl
    }

    function handleChatScreenPop(incommingSession) {
        if (incommingSession.screenPop && incommingSession.screenPop !== null && incommingSession.screenPop !== "") {
            let chat = store.getState().digital.answeredChats;
            let chatScreenPopList = store.getState().digital.chatScreenPops;

            let loginDetails = store.getState().toolbar.loginDetails
            let url = getChatScreenPopUrl(chat[incommingSession.sessionId]);
            console.log("Chat Screen Pop URL: ", url)
            if (url && loginDetails && loginDetails.agentInfo) {
                const screenPopMode = loginDetails.agentInfo.user.screenPopMode;
                if (screenPopMode !== 1) {
                    if (screenPopMode === 3) {
                        openWindow(url, '_blank', '', incommingSession.sessionId)
                    } else {
                        openWindow(url, "ozo_screen", "status=1,width=1024,height=600", incommingSession.sessionId)
                    }
                } else {
                    store.dispatch(addNewTab(incommingSession.custName))
                    store.dispatch(setActiveTab(incommingSession.custName))
                    LocalStorageService.setItem("DashboardActiveTab", incommingSession.custName)
                    let custDetails = JSON.parse(incommingSession.chatDetails)
                    const temp = [...chatScreenPopList]; // Create a copy of the current PopList
                    const exists = temp.some(pop => pop.custMail === custDetails.email && pop.custPhone === custDetails.phoneNumber);
                    if (!exists) {
                        temp.push({
                            name: incommingSession.custName,
                            sessionId: incommingSession.sessionId,
                            url: url,
                            custMail: custDetails.email,
                            custPhone: custDetails.phoneNumber
                        });
                        store.dispatch(setChatScreenpops(temp));
                    }
                }
            }
        }
    }
    function openWindow(url, type, style, sessionId) {
        let storedWindows = JSON.parse(localStorage.getItem('windows')) || [];
        const isAlreadyExists = storedWindows.find((win) => win.id === sessionId);
        if (!isAlreadyExists) {
            if (type === '_blank') {
                window.open(url, `window${sessionId}`);
            }
            else {
                window.open(url, `window${sessionId}`, type, style);
            }
            storedWindows.push({ id: sessionId })
            localStorage.setItem('windows', JSON.stringify(storedWindows));
        }
    };
    function handleAgentLogoffByAdmin(message) {
        agentForceLogoutByAdmin = true;
        closeAllPreviewScreenpops();
        PreviewReset();
        store.dispatch(setAgentLogoffByAdmin(true))
    }

    async function handleAgentReleaseByAdmin(message) {
        closeAllPreviewScreenpops();
        PreviewReset(true);
        removeTranscribeTab();
        if (Object.keys(message).includes("disposition") || message?.who === "WrapupDispositionScript" || message?.who === "DispositionAPI") {
            handleScreenPopClose(store.getState().call.callDetails ? store.getState().call.callDetails.ucid : '', 'chatCall');
        }
        try {
            if (message?.who !== "WrapupDispositionScript" && message?.who !== "DispositionAPI") {
                await releaseAgent({ mes: message.who?.trim() ? "agentReleaseByAdmin:" + message.who : "agentReleaseByAdmin", who: message.who });
            }

        } catch (e) {
            console.log(e)
        }
        if (Object.keys(message).includes("disposition") || message?.who === "WrapupDispositionScript") {
            handleDropCall({ ucid: store.getState().call.callDetails ? store.getState().call.callDetails.ucid : '' });

        } else {
            store.dispatch(setAgentState(AGENT_STATE.READY));
            if (store.getState().call.isCallActivityPresent) {
                aToolbar !== undefined && aToolbar.trigger("setDisposition", [store.getState().call.callDetails, "", ""]);
                handleDropCall({ type: "agentReleaseWOACW", ucid: store.getState().call.callDetails ? store.getState().call.callDetails.ucid : '' });
            } else if (store.getState().digital.isChatActive && message?.who !== "CA_App") {
                store.dispatch(handleChatAcceptStatus(false));
            }
        }

        store.dispatch(setWrapUpTimeExceeded(false));
        store.dispatch(setWrapUpTime(0));
    }

    async function newChatSession(message) {  // incoming new chat ( auto answer is disable case)
        let answeredChats = store.getState().digital.answeredChats;
        let unansweredChats = store.getState().digital.unansweredChats;
        const mode = store.getState().toolbar.agent.mode;
        const isCallInComming = store.getState().call.isCallIncomming;
        await PreviewReset(true)
        displayChatOnCallMiniWindow()
        notifyNewChat(message);
        store.dispatch(handleNewIncomingChatRequest(message))
        let chatObj = JSON.parse(message.chatDetails)
        if (!(store.getState().digital.declinedChatsMonitorUcids.includes(chatObj.monitorUcid))) {
            let obj = { ...message, chatDetails: JSON.parse(message.chatDetails), monitorUcid: chatObj.monitorUcid, ucid: chatObj.monitorUcid, did: chatObj.did, skillName: chatObj.skill, callerId: chatObj.phoneNumber, callType: `Digital - ${chatObj.channelType} `, callStartTime: new Date().toISOString() }
            aToolbar !== undefined && aToolbar.trigger("chatonmulti", [obj]);
        }
        if (isCallInComming && mode === "blended" && ((Object.values(unansweredChats).length >= 0 || Object.values(answeredChats).length > 0))) {
            store.dispatch(setCallOnChatORChatOnCallAvailable(true));
            store.dispatch(setIsCallIncomming(false));
        }
    }

    return services;
}());

export default WSocketService;